import { render, staticRenderFns } from "./EditResults.vue?vue&type=template&id=68f1c089&"
import script from "./EditResults.vue?vue&type=script&lang=js&"
export * from "./EditResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports